import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Form, Model, Operation } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'

export default function CopyChecklistTemplateSmartview ({ id }) {
  const footer = (
    <UI.ButtonWrap>
      <UI.SubmitButton>
        <Translation name="generic.copy"/>
      </UI.SubmitButton>
    </UI.ButtonWrap>
  )

  return (
    <Translator namespace="checklists">
      <Model resourceName="checklists.checklist_templates" id={id}>
        <Operation namespace="api" resourceName="checklists" operationName="copy">
          <Form submitTo="copy" className="form-field">
            <Smartview footer={footer} header={<Translation name="checklists.titles.copy"/>}>
              <Fieldset>
                <Fields.ResourceSelector
                  name="department_id"
                  optionsKey="name"
                  resourceName="departments"
                  operationName="select"
                  label={<Translation name="fields.department.label"/>}
                  multiple={false}
                />
              </Fieldset>
            </Smartview>
          </Form>
        </Operation>
      </Model>
    </Translator>
  )
}
